import { makeStyles } from "@material-ui/core/styles";

const appBarUserDetailsStyles = makeStyles(() => ({
	leftBorderWhite: {
		border: 0,
		borderStyle: "solid",
		borderLeftWidth: 1,
		borderColor: "#ffffff",
	},
}));
export default appBarUserDetailsStyles;
